import React, { Fragment } from "react";
import AppRouter from "./routers/AppRouter";
import { ColaboradoresProvider } from "./contexts/Colaboradores";
import { AuthStrapiProvider } from "./contexts/StrapiV3Auth";

function App() {
  return (
    <Fragment>
      <AuthStrapiProvider>
        <ColaboradoresProvider>
          <AppRouter />
        </ColaboradoresProvider>
      </AuthStrapiProvider>
    </Fragment>
  );
}

export default App;
